import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2360e7ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "device-details-overview" }
const _hoisted_2 = { class: "columns is-multiline h-100" }
const _hoisted_3 = { class: "column is-12-touch is-9-desktop is-9-widescreen h-100" }
const _hoisted_4 = { class: "columns indicators is-multiline" }
const _hoisted_5 = { class: "column is-12-mobile is-6-tablet is-4-desktop is-2-widescreen" }
const _hoisted_6 = {
  key: 0,
  class: "column is-12-mobile is-6-tablet is-4-desktop is-2-widescreen"
}
const _hoisted_7 = {
  key: 1,
  class: "column is-12-mobile is-6-tablet is-4-desktop is-2-widescreen"
}
const _hoisted_8 = { class: "column is-12-mobile is-6-tablet is-4-desktop is-2-widescreen" }
const _hoisted_9 = { class: "column is-12-mobile is-6-tablet is-4-desktop is-2-widescreen" }
const _hoisted_10 = { class: "column is-12-mobile is-6-tablet is-4-desktop is-2-widescreen" }
const _hoisted_11 = { class: "column is-12-mobile is-6-tablet is-4-desktop is-2-widescreen" }
const _hoisted_12 = { class: "columns chart is-multiline" }
const _hoisted_13 = { class: "column h-100 is-12" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1 /* HOISTED */))
const _hoisted_15 = { class: "column is-12-touch is-3-desktop is-3-widescreen timeline" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_widget_indicator = _resolveComponent("widget-indicator")!
  const _component_chart_station_events = _resolveComponent("chart-station-events")!
  const _component_station_events_timeline = _resolveComponent("station-events-timeline")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_widget_indicator, {
              class: "h-100",
              title: _ctx.$t('device_details.information.status_label'),
              value: _ctx.status?.short,
              valueColor: _ctx.status?.color,
              description: _ctx.$t('device_details.overview.indicators_status_description')
            }, null, 8 /* PROPS */, ["title", "value", "valueColor", "description"])
          ]),
          (!_ctx.inPPM)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_widget_indicator, {
                  class: "h-100",
                  title: _ctx.$t('indicators.ch4_lel.label'),
                  value: _ctx.lel,
                  valueColor: _ctx.lelColor,
                  description: _ctx.$t('indicators.ch4_lel.description')
                }, null, 8 /* PROPS */, ["title", "value", "valueColor", "description"])
              ]))
            : _createCommentVNode("v-if", true),
          (_ctx.inPPM)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_widget_indicator, {
                  class: "h-100",
                  title: _ctx.$t('indicators.ch4.label'),
                  value: _ctx.ppm,
                  valueColor: _ctx.ppmColor,
                  description: _ctx.$t('indicators.ch4.description')
                }, null, 8 /* PROPS */, ["title", "value", "valueColor", "description"])
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_widget_indicator, {
              class: "h-100",
              title: _ctx.$t('indicators.run_time.label'),
              value: _ctx.runtime,
              description: _ctx.$t('indicators.run_time.description')
            }, null, 8 /* PROPS */, ["title", "value", "description"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_widget_indicator, {
              class: "h-100",
              title: _ctx.$t('indicators.network.label'),
              value: _ctx.network?.label || '-',
              valueColor: _ctx.network?.color,
              description: _ctx.$t('indicators.network.description'),
              tooltip: _ctx.network?.tooltip
            }, null, 8 /* PROPS */, ["title", "value", "valueColor", "description", "tooltip"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_widget_indicator, {
              class: "h-100",
              title: _ctx.$t('indicators.temperature.label'),
              value: _ctx.temperature,
              unit: _ctx.$t('indicators.temperature.unit'),
              description: _ctx.$t('indicators.temperature.description')
            }, null, 8 /* PROPS */, ["title", "value", "unit", "description"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_widget_indicator, {
              class: "h-100",
              title: _ctx.$t('indicators.humidity.label'),
              value: _ctx.humidity,
              unit: _ctx.$t('indicators.humidity.unit'),
              description: _ctx.$t('indicators.humidity.description')
            }, null, 8 /* PROPS */, ["title", "value", "unit", "description"])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_chart_station_events, {
              class: "h-100",
              station: _ctx.station,
              since: _ctx.since,
              before: _ctx.before,
              events: _ctx.events
            }, null, 8 /* PROPS */, ["station", "since", "before", "events"])
          ])
        ]),
        _hoisted_14
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_station_events_timeline, {
          class: "h-100 w-100",
          station: _ctx.station,
          events: _ctx.events
        }, null, 8 /* PROPS */, ["station", "events"])
      ])
    ])
  ]))
}